import * as NotificationsApi from "../../../api/NotificationsApi";
import {
    fetchNotificationCounterBegin,
    fetchNotificationCounterFailure,
    fetchNotificationCounterSuccess
} from "../action/notificationCounterAction";

export function fetchNotificationCounter() {
    return dispatch => {
        dispatch(fetchNotificationCounterBegin());
        NotificationsApi.notificationCountForCurrentUser().then((res) => {
            // AxiosAgent resolves on API errors too, so the failure shape has to be
            // checked here — otherwise a failed fetch dispatched success with 0 and
            // left the reducer stuck in its loading state.
            if (res?.data?.type === "serverError") {
                dispatch(fetchNotificationCounterFailure(res.data.payload?.message));
                return;
            }
            dispatch(fetchNotificationCounterSuccess(res.data?.id || 0));
        }).catch((error) => {
            dispatch(fetchNotificationCounterFailure(error));
        });
    };
}
